module.exports = __webpack_public_path__ + "static/media/dp_logo.f2512300.png";